import api from './api';
import { Dish, CreateDishDto, UpdateDishDto, DishPortion, CreateDishPortionDto, UpdateDishPortionPriceDto, DishPortionPrice } from '../types/dish.types';

export const dishService = {
  async getAllDishes(): Promise<Dish[]> {
    const response = await api.get<Dish[]>('/dishes');
    return response.data;
  },

  async getDishById(id: number): Promise<Dish> {
    const response = await api.get<Dish>(`/dishes/${id}`);
    return response.data;
  },

  async createDish(data: CreateDishDto): Promise<Dish> {
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.image) {
      formData.append('image', data.image);
    }

    const response = await api.post<Dish>('/dishes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async updateDish(id: number, data: UpdateDishDto): Promise<Dish> {
    const formData = new FormData();
    if (data.name) {
      formData.append('name', data.name);
    }
    if (data.image) {
      formData.append('image', data.image);
    }
    if (data.is_active !== undefined) {
      formData.append('is_active', String(data.is_active));
    }

    const response = await api.patch<Dish>(`/dishes/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async deleteDish(id: number): Promise<void> {
    await api.delete(`/dishes/${id}`);
  },

  async archiveDish(id: number): Promise<Dish> {
    const response = await api.patch<Dish>(`/dishes/${id}/archive`);
    return response.data;
  },

  // Методы для работы с граммовками
  async createPortion(data: CreateDishPortionDto): Promise<DishPortion> {
    console.log('Отправка граммовки:', data); // Для отладки
    const response = await api.post<DishPortion>('/dishes/portions', data);
    return response.data;
  },

  async getPortionsByDish(dishId: number): Promise<DishPortion[]> {
    const response = await api.get<DishPortion[]>(`/dishes/${dishId}/portions`);
    return response.data;
  },

  async deletePortion(portionId: number): Promise<DishPortion> {
    const response = await api.delete<DishPortion>(`/dishes/portions/${portionId}`);
    return response.data;
  },

  // Методы для работы с ценами
  async updatePrice(priceId: number, data: UpdateDishPortionPriceDto): Promise<DishPortionPrice> {
    const response = await api.patch<DishPortionPrice>(`/dishes/prices/${priceId}`, data);
    return response.data;
  },

  async getPricesByPortion(portionId: number): Promise<DishPortionPrice[]> {
    const response = await api.get<DishPortionPrice[]>(`/dishes/portions/${portionId}/prices`);
    return response.data;
  },

  // Вспомогательная функция для получения полного URL изображения
  getImageUrl(imagePath: string | null): string | null {
    if (!imagePath) return null;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    return `${baseUrl}${imagePath}`;
  },
};
